export const commonEnv = {
  production: false,
  name: 'development',
  apiEndpoint: 'http://localhost:5000/api/',
  googleMapsAPIKey: 'AIzaSyDrwC5HM6VQNKUzsyTFkxtBpVCtBn3csvA', // shared
  rollbarAccessToken: '95867e41c9434f0a8b382f3a554c3b66', // shared
};
